import { useApiClient } from '../../hooks/useApiClient';
import { BuilderVocabularyItem } from '../../types/SimilarlySituated/BuilderVocabularyItem.type';
import { BuilderStage } from '../../types/SimilarlySituated/BuilderStage.type';

export const useBuilderVocabularyApi = () => {
  const apiClient = useApiClient();

  return {
    getBuilderStages: (): Promise<BuilderStage[]> => apiClient(`/builder_stages/`),

    getBuilderStatuteLevels: (): Promise<BuilderVocabularyItem[]> => apiClient(`/builder_statute_levels/`),

    getBuilderStagePositions: (): Promise<BuilderVocabularyItem[]> => apiClient(`/builder_stage_positions/`),

    getBuilderCaseDispositions: (): Promise<BuilderVocabularyItem[]> => apiClient(`/builder_case_dispositions/`),

    getBuilderAges: (): Promise<BuilderVocabularyItem[]> => apiClient(`/builder_ages/`),

    getBuilderCodefendantStatuses: (): Promise<BuilderVocabularyItem[]> => apiClient(`/builder_codefendant_statutes/`),

    getBuilderDateWindowStages: (): Promise<BuilderVocabularyItem[]> => apiClient(`/builder_date_window_stages/`),

    getBuilderOffenceGroupingTypes: (): Promise<BuilderVocabularyItem[]> =>
      apiClient(`/builder_offence_grouping_types/`),
  };
};
